import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPlayerName, setPlayerName, WaitForAuthEffect } from '../../util/device-id';
import { useTranslation } from 'react-i18next';
import { getUnusedGameId } from '../../firebase/firebase-db.ts';
import { Button } from '../../components/home/buttons';
import { Input } from '@/components/home/input.tsx';
import { isValidGameId } from '@/util/index.ts';

export function CreateRoute() {
    const navigate = useNavigate();
    const [gameId, setGameId] = useState<string | undefined | null>(null);
    const [name, setName] = useState(getPlayerName());
    const [isLoading, setIsLoading] = useState(false);
    const [hasAuth, setHasAuth] = useState('');
    const { t } = useTranslation();

    const canCreateGame = useMemo(() => {
        return Boolean(gameId && isValidGameId(gameId) && name?.trim()?.length >= 4 && hasAuth);
    }, [gameId, name, hasAuth]);

    useEffect(() => {
        getUnusedGameId().then(setGameId);
        WaitForAuthEffect().then(setHasAuth);
    }, []);

    function playerNameChanged(event: React.ChangeEvent<HTMLInputElement>) {
        const value = (event.target.value).trim();
        setPlayerName(value);
        setName(value);
    }

    async function OnGoToSetup() {
        if (canCreateGame) {
            setIsLoading(true);
            navigate(`/create/${gameId}`);
        }
    }

    return (
        <div className="w-full space-y-2 animate-slideinbottom">
            <h2 className="text-2xl text-center">{t('create.headingNamePrompt')}</h2>
            <Input autoFocus placeholder={t('create.placeholderName')} value={name} onChange={playerNameChanged} />
            <Button hotkey={{ key: 'Enter', display: '⏎', allowInInput: true }} className="w-full" isLoading={isLoading} disabled={!canCreateGame} onClick={OnGoToSetup}>{t('create.btnOk')}</Button>
        </div>
    );
}
